import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

@Injectable()
export class ConfigActions {

  static UPDATE_CURRENT_VIEW = 'Config.UpdateCurrentView';
  static UPDATE_CURRENT_MENU = 'Config.UpdateCurrentMenu';

  constructor( private _store: Store<IAppState>){
  }

  public updateCurrentView(currentView: string): any {
    return this._store.dispatch({
      type:  ConfigActions.UPDATE_CURRENT_VIEW,
      payload: currentView
    });
  }


  public updateCurrentMenu(currentMenu: string): any {
    return this._store.dispatch({
      type:  ConfigActions.UPDATE_CURRENT_MENU,
      payload: currentMenu
    });
  }
}
